import { FeeType, ItineraryFragment, SectionFragment } from 'generated/graphql';

const calculateItineraryPrice = ({ itinerary, defaultFeeType }) => {
  const { price } =
    itinerary.fees.find(({ type }) => type.id === defaultFeeType.id) || {};
  return price ? price.amount : 0;
};

const iso8601HourRegExp = /^\d+-\d{2}-\d{2}T(\d{2}):\d{2}:\d{2}/;

export const calculateHour = (sections: { departureDate: string }[]) => {
  const departureDate: string = sections[0].departureDate;
  const [, hourString] = iso8601HourRegExp.exec(departureDate) || ['', ''];
  return parseInt(hourString);
};

export const PricesPerHourCollector = (): {
  add: (arg: { hour: number; price: number }) => void;
  build: () => Map<number, number>;
} => {
  const pricesPerHour = new Map<number, number>();
  return {
    add({ hour, price }) {
      const currentPriceInHour = pricesPerHour.get(hour);
      if (!currentPriceInHour || currentPriceInHour > price) {
        pricesPerHour.set(hour, price);
      }
    },
    build() {
      return pricesPerHour;
    },
  };
};

export type DepartureTimeLegCollectorReturnType = {
  add: (arg: {
    itinerary: ItineraryFragment;
    sections: SectionFragment[];
    defaultFeeType?: FeeType | null;
  }) => void;
  build: () => {
    maxPricePerHour: number;
    pricesPerHour: { hour: number; price: number }[];
  };
};
const DepartureTimeLegCollector = (): DepartureTimeLegCollectorReturnType => {
  let itineraryId;
  let price;
  const pricesPerHourCollector = PricesPerHourCollector();
  return {
    add({ itinerary, sections, defaultFeeType }) {
      if (itineraryId !== itinerary.id) {
        itineraryId = itinerary.id;
        price = calculateItineraryPrice({ itinerary, defaultFeeType });
      }
      const hour = calculateHour(sections);
      pricesPerHourCollector.add({ hour, price });
    },
    build() {
      const pricesPerHourMap = pricesPerHourCollector.build();
      const maxPricePerHour = Math.max(...pricesPerHourMap.values());
      const pricesPerHour = Array.from({ length: 24 }, (_, hour) => {
        const price = pricesPerHourMap.get(hour) || 0;
        return {
          hour,
          price,
        };
      });
      return {
        maxPricePerHour,
        pricesPerHour,
      };
    },
  };
};

export default DepartureTimeLegCollector;
